function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.122,17.569a18.3,18.3,0,1,1-21.788-13.3A18.3,18.3,0,0,1,40.122,17.569Z",
  transform: "translate(5.29 4.907)",
  fill: "#1590cf"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.733,27.965a4.844,4.844,0,0,0-4.816-4.816H14a4.621,4.621,0,0,0-3.44-5.734H4.6a17.889,17.889,0,0,0,4.358,15.6h5.963A5.046,5.046,0,0,0,19.733,27.965ZM25.7,8.011v.917H23.632a5.046,5.046,0,0,0,0,10.091H40.374a17.486,17.486,0,0,0-9.4-14.22H28.907A3.135,3.135,0,0,0,25.7,8.011ZM40.374,22.461H30.512a4.112,4.112,0,0,0-4.128,4.128,6.7,6.7,0,0,0,.459,2.064A4.156,4.156,0,0,0,24.09,33.7a3.741,3.741,0,0,0,3.9,2.752h2.752a18.226,18.226,0,0,0,9.633-13.99Z",
  transform: "translate(5.496 6.208)",
  fill: "#59b4d9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.339,14.678a.493.493,0,0,1-.459-.459A6.422,6.422,0,0,0,.459,7.8C.229,8.027,0,7.569,0,7.339a.493.493,0,0,1,.459-.459A6.422,6.422,0,0,0,6.881.459C6.881,0,7.11,0,7.339,0s.688,0,.688.459a6.422,6.422,0,0,0,6.422,6.422.459.459,0,1,1,0,.917A6.422,6.422,0,0,0,8.027,14.22c0,.229-.229.459-.688.459Z",
  fill: "#1590cf"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.758,26.657c-.229,0-.229,0-.229-.229a3.821,3.821,0,0,0-3.9-3.67c-.229,0-.229,0-.229-.229s0-.229.229-.229a3.979,3.979,0,0,0,3.9-3.67c0-.229,0-.229.229-.229s.229,0,.229.229a3.821,3.821,0,0,0,3.9,3.67c.229,0,.229,0,.229.229s0,.229-.229.229a3.979,3.979,0,0,0-3.9,3.67C23.216,26.657,22.987,26.657,22.758,26.657Z",
  transform: "translate(23.801 23.801)",
  fill: "#59b4d9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.161,6.116C52.326,3.364,48.2,2.676,41.546,4.281a45.3,45.3,0,0,0-5.963,1.835,17.974,17.974,0,0,1,3.44,2.294c1.147-.229,2.294-.688,3.211-.917A20.823,20.823,0,0,1,47.51,6.8c2.064,0,3.211.459,3.67,1.147.688,1.147,0,3.9-3.67,8.257A21.622,21.622,0,0,1,45.216,18.5a78.159,78.159,0,0,1-13.761,10.55,63.988,63.988,0,0,1-15.6,7.11C9.208,38.225,4.621,38.225,3.7,36.619s.917-5.734,5.963-10.55a25.272,25.272,0,0,1-.459-4.128c-7.8,7.11-10.321,13.3-8.486,16.513A8.05,8.05,0,0,0,7.6,41.206a34.51,34.51,0,0,0,11.7-2.523A77.12,77.12,0,0,0,33.061,31.8a96.025,96.025,0,0,0,12.385-9.174A39.09,39.09,0,0,0,49.8,18.271C54.39,13,55.766,8.868,54.161,6.116Z",
  transform: "translate(0.195 4.435)",
  fill: "#046eab"
});

var SvgAzureCosmosDb = function SvgAzureCosmosDb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50.457,
    viewBox: "0 0 55 50.457",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAzureCosmosDb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/azure_cosmos_db.74849076.svg";
export { ForwardRef as ReactComponent };